import React, { createContext, useEffect } from "react";
import { LanguageInfo, languages } from "@/lib/LanguageUtils";
type LanguageSelectionMap = {
  [languageCode: string]: string;
};
const LanguageFlagContext = createContext<{
  selectedCountries: LanguageSelectionMap;
  setLanguageCountry: (languageCode: string, countryCode: string) => void;
  languagesWithOverrideOption: string[];
} | null>(null);
export const LanguageFlagContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({
  children
}) => {
  const [selectedCountries, setSelectedCountries] = React.useState<LanguageSelectionMap>({
    en: "GB",
    zh: "CN",
    ar: "AE",
    pt: "BR",
    es: "ES"
  });
  const setLanguageCountry = (languageCode: string, countryCode: string) => {
    setSelectedCountries(prev => ({
      ...prev,
      [languageCode]: countryCode
    }));
  };
  const languagesWithOverrideOption = ["en", "zh", "ar", "pt", "es"];
  return <LanguageFlagContext.Provider value={{
    selectedCountries,
    setLanguageCountry,
    languagesWithOverrideOption
  }} data-sentry-element="unknown" data-sentry-component="LanguageFlagContextProvider" data-sentry-source-file="LanguageFlagContext.tsx">
            {children}
        </LanguageFlagContext.Provider>;
};
export const useLanguageFlagContext = () => {
  const context = React.useContext(LanguageFlagContext);
  if (!context) {
    throw new Error("useLanguageFlagContext must be used within a LanguageProvider");
  }
  return context;
};
export function useEffectiveLanguageInfo(code: string): LanguageInfo | undefined {
  const {
    selectedCountries
  } = useLanguageFlagContext();
  const lang = languages.find(lang => lang.code === code);
  if (!lang) return undefined;
  const overrideCountryCode = selectedCountries[code];
  if (overrideCountryCode && lang.countryCodes?.some(c => c.countryCode === overrideCountryCode)) {
    return {
      ...lang,
      countryCode: overrideCountryCode
    };
  }
  return lang;
}